import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React from 'react';
import { DateFormats, formatDate } from 'src/utils/time';

interface DatePickerFieldProps {
  value: string;
  onChange: (isoDate: string) => void;
  usePortal?: boolean;
  isOpen?: boolean;
  onToggle?: (open: boolean) => void;
  'data-testid'?: string;
}

export const DatePickerField: React.FC<DatePickerFieldProps> = ({
  value,
  onChange,
  usePortal = false,
  isOpen: controlledIsOpen,
  onToggle,
  'data-testid': dataTestId = 'date-picker-field',
}) => {
  const [internalOpen, setInternalOpen] = React.useState(false);
  const isOpen = controlledIsOpen ?? internalOpen;

  const handleOpen = () => {
    if (onToggle) onToggle(true);
    else setInternalOpen(true);
  };
  const handleClose = () => {
    if (onToggle) onToggle(false);
    else setInternalOpen(false);
  };

  const picker = (
    <DatePicker
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      value={value ? dayjs(value) : null}
      onChange={(date) => {
        if (date) {
          onChange(formatDate(date, DateFormats.YYYY_MM_DD, false));
        }
        handleClose();
      }}
      format="MM/DD/YYYY"
      slotProps={{
        textField: {
          fullWidth: true,
          onClick: handleOpen,
          inputProps: { readOnly: true },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ...(dataTestId ? ({ 'data-testid': dataTestId } as any) : {}),
        },
        popper: usePortal
          ? {
              container:
                document.querySelector<HTMLElement>(
                  '[data-testid="form-preview-slideout"]',
                ) || document.body,
            }
          : undefined,
      }}
    />
  );

  if (usePortal) return picker;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {picker}
    </LocalizationProvider>
  );
};
